import { TRootState } from "../reducers/RootReducer";

/**
 * Gets whether the initial load has finished
 */
export const selectHasLoaded = (store: TRootState) => store.data.loadedAt !== undefined;

export const selectArchiveTerms = (state: TRootState) => state.data.archiveTerms;

export const selectAnnouncements = (state: TRootState) => state.data.announcements;
